import React, { useState } from 'react';
import { Building, Users, Plus, Save, X, Pencil, Trash2, ChevronDown, ChevronUp, ImageIcon, User } from 'lucide-react';
import '../../styles/shared.css';

const ClubForm = ({
  showClubForm,
  editingClub,
  clubForm,
  setClubForm,
  addClub,
  cancelClubForm,
  uploadingImage,
  currentClubs,
  editClub,
  deleteClub,
  expandedClubs,
  toggleExpandClub,
  handleFileChange,
  clearImagePreview,
  setShowClubForm,
  setEditingClub,
  newGymnastForm,
  setNewGymnastForm,
  addGymnastToClubForm,
  removeGymnastFromClubForm,
  editGymnastInForm,
  editingGymnast,
  setEditingGymnast,
  LEVEL_OPTIONS,
  FRANJA_OPTIONS,
  openGymnastSearch
}) => {
  const [filterLevel, setFilterLevel] = useState('');

  if (!showClubForm) {
    return (
      <div className="card">
        <div className="card-header">
          <div className="header-left">
            <Building size={20} color="#8b5cf6" />
            <h2>Clubes y Atletas</h2>
          </div>
          <div className="header-right">
            <button onClick={openGymnastSearch} className="btn btn-secondary">
              <Users size={16} />
              Buscar Atletas
            </button>
            <button
              onClick={() => {
                setEditingClub(null);
                setEditingGymnast(null);
                setClubForm({ 
                  name: '', 
                  gymnasts: [], 
                  imageFile: null, 
                  imagePreview: null 
                });
                setNewGymnastForm({ 
                  name: '', 
                  level: '', 
                  franja: '', 
                  imageFile: null, 
                  imagePreview: null 
                });
                setShowClubForm(true);
              }}
              className="btn btn-primary"
            >
              <Plus size={16} />
              Nuevo Club
            </button>
          </div>
        </div>

        <div className="club-list">
          {(Array.isArray(currentClubs) ? currentClubs : []).map(club => (
            <div key={club.id} className="club-item">
              <div className="club-header">
                <div className="club-info">
                  <button
                    onClick={() => toggleExpandClub(club.id)}
                    className="expand-btn"
                  >
                    {expandedClubs[club.id] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </button>
                  <div className="club-details">
                    {club.image_url ? (
                      <img src={club.image_url} alt={club.name} className="club-image" />
                    ) : (
                      <div className="club-icon">
                        <Building size={20} />
                      </div>
                    )}
                    <div className="club-name">{club.name}</div>
                    <span className="gymnast-count">
                      {club.gymnasts.length} atletas
                    </span>
                  </div>
                </div>
                <div className="club-actions">
                  <button onClick={() => editClub(club)} className="btn-icon" title="Editar club">
                    <Pencil size={12} />
                    Editar
                  </button>
                  <button onClick={() => deleteClub(club.id)} className="btn-icon danger" title="Eliminar club">
                    <Trash2 size={12} />
                    Eliminar
                  </button>
                </div>
              </div>

              {expandedClubs[club.id] && club.gymnasts.length > 0 && (
                <div className="gymnast-list">
                  {club.gymnasts.map(gymnast => (
                    <div key={gymnast.id} className="gymnast-item">
                      <div className="gymnast-info">
                        <div className="gymnast-icon">
                          <User size={24} />
                        </div>
                        <div className="gymnast-details">
                          <div className="gymnast-name">{gymnast.name}</div>
                          <div className="gymnast-stats">
                            {gymnast.level} | {gymnast.franja}
                          </div>
                          <div className="gymnast-scores">
                            <span>Suelo: {gymnast.scores.Suelo?.toFixed(1) || '0.0'}</span>
                            <span>Viga: {gymnast.scores.Viga?.toFixed(1) || '0.0'}</span>
                            <span>Barras: {gymnast.scores.Barras?.toFixed(1) || '0.0'}</span>
                            <span>Salto: {gymnast.scores.Salto?.toFixed(1) || '0.0'}</span>
                          </div>
                        </div>
                      </div>
                      <div className="gymnast-totals">
                        <div className="all-round">All-Round: {gymnast.allRound.toFixed(2)}</div>
                        <div className="total">Total: {gymnast.total.toFixed(2)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h2>{editingClub ? 'Editar Club' : 'Nuevo Club'}</h2>
      </div>
      
      <div className="form-container">
        <div className="form-group">
          <label>Nombre del Club</label>
          <input
            type="text"
            placeholder="Nombre del club"
            value={clubForm.name}
            onChange={(e) => setClubForm({...clubForm, name: e.target.value})}
            className="input-field"
          />
        </div>

        <div className="form-group">
          <label>Ubicación / Dirección</label>
          <input
            type="text"
            placeholder="Ubicación o dirección del club"
            value={clubForm.location || ''}
            onChange={(e) => setClubForm({...clubForm, location: e.target.value})}
            className="input-field"
          />
        </div>

        <div className="form-group">
          <label>Logo (opcional)</label>
          <div className="image-upload">
            <label className="btn btn-secondary">
              <ImageIcon size={14} />
              {clubForm.imagePreview ? 'Cambiar Logo' : 'Seleccionar Logo'}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, setClubForm)}
                style={{ display: 'none' }}
              />
            </label>
            
            {clubForm.imagePreview && (
              <button
                onClick={() => clearImagePreview(setClubForm)}
                className="btn-icon danger"
              >
                <X size={14} />
                Eliminar
              </button>
            )}
          </div>
          
          {clubForm.imagePreview && (
            <div className="image-preview">
              <div className="preview-label">Vista previa:</div>
              <img
                src={clubForm.imagePreview}
                alt="Preview"
                className="preview-image"
              />
            </div>
          )}
        </div>

        <div className="form-actions">
          <button
            onClick={addClub}
            disabled={uploadingImage}
            className="btn btn-success"
          >
            <Save size={16} />
            {uploadingImage ? 'Subiendo...' : (editingClub ? 'Actualizar Club' : 'Guardar Club')}
          </button>
          <button
            onClick={cancelClubForm}
            disabled={uploadingImage}
            className="btn btn-secondary"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClubForm;